import React, { useState, useEffect, useRef } from "react";

import Header from "../../layout/header";
import Footer from "../../layout/footer";
import bg from "../../assets/img/thematicAreas/3.jpg";
// import footer from "../../assets/img/banner-whatwedo.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import card1 from "../../assets/img/thematicAreas/4.jpg";
import card2 from "../../assets/img/thematicAreas/5.jpg";
import card3 from "../../assets/img/thematicAreas/6.jpg";
import card4 from "../../assets/img/thematicAreas/7.jpg";
import card5 from "../../assets/img/thematicAreas/8.jpg";

const thematicData = [
  {
    id: "section-culture",
    title: "SEP and Culture",
    bgImage: card1,
    isWideBanner: false,
    detail: `Sufficiency Economy Philosophy (SEP) is deeply rooted in traditional values that emphasise moderation, reasonableness, and prudence – principles reflected in many cultural practices across Southeast Asia. These principles are evident in practices related to communal resource sharing, mindful consumption, and long-term environmental stewardship, which have been passed down through generations. In schools, integrating SEP with local cultural practices can strengthen students’ sense of identity and belonging while promoting empathy, understanding and respect for cultural diversity. By linking classroom learning with community traditions, schools can encourage students to appreciate how cultural wisdom contributes to resilience, social harmony, and sustainable living. In this way, SEP resonates with the values and identities of diverse Southeast Asian societies.`,
  },
  {
    id: "section-technology",
    title: "SEP and Technology",
    bgImage: card2,
    isWideBanner: false,
    detail: `Sufficiency Economy Philosophy (SEP) provides an ethical compass for the adoption and use of technology, ensuring that innovation is socially inclusive and environmentally responsible. In education, this means using digital tools and emerging technologies in ways that enhance learning rather than create dependency or widen inequality. Whether through digital classrooms, technology for personalised learning, or innovations like precision agriculture and renewable energy in school projects, SEP encourages thoughtful decision-making, supported by ethics and knowledge. By applying SEP principles, schools can guide students to view technology as a tool for empowerment and problem-solving, cultivating a mindset that values long-term well-being over short-term convenience.`,
  },
  {
    id: "section-lifeskills",
    title: "SEP and Life Skills",
    bgImage: card3,
    isWideBanner: false,
    detail: `Sufficiency Economy Philosophy (SEP) naturally aligns with the development of essential life skills needed for the 21st century. By nurturing moderation, reasonableness, and prudent decision-making, SEP helps learners build resilience, adaptability, and self-reliance – skills critical for lifelong learning and sustainable living. In schools, SEP can be integrated into lessons and activities that build self-discipline, empathy, critical thinking, financial literacy, and problem-solving. Students are encouraged to work collaboratively, manage risks, and contribute meaningfully to their communities. In this way, SEP not only equips young people with practical competencies but also shapes values and mindsets that prepare them to face emerging global challenges with confidence and responsibility.`,
  },
  {
    id: "section-economy",
    title: "SEP and Economy",
    bgImage: card4,
    isWideBanner: false,
    detail: `Sufficiency Economy Philosophy (SEP) provides a practical framework for developing sustainable and resilient economies, starting from the school level. Its principles of moderation, reasonableness, and prudence encourage balanced decision-making, self-reliance, and ethical use of resources – values that can be cultivated from an early age. Schools can promote economic resilience through experiential learning activities such as school-based enterprises, social entrepreneurship projects, and lessons on green and circular economies. These initiatives help students understand how responsible financial choices contribute to long-term stability and social equity. By applying SEP in school settings, young people develop the knowledge and values needed to support inclusive and sustainable economic growth in their communities.`,
  },
  {
    id: "section-environment",
    title: "SEP and Environment",
    bgImage: card5,
    isWideBanner: false,
    detail: `The close relationship between SEP and environmental stewardship makes it a valuable approach for education for sustainable development. SEP’s core principles encourage individuals and communities to use resources responsibly, reduce waste, and protect ecosystems. Schools can translate these principles into practical activities such as sustainable gardening, waste reduction campaigns, or biodiversity conservation projects. These give students hands-on experience in caring for the environment. By linking daily school life with environmental responsibility, SEP helps students understand that economic and social progress must go hand-in-hand with ecological sustainability, nurturing a generation that values harmony with nature.`,
  },
  {
    id: "section-cross-cutting",
    title: "SEP and Cross-cutting Challenges",
    bgImage: null, // ไม่มีรูป เพราะใช้ CSS Gradient แทนตามรูปตัวอย่าง
    isWideBanner: true,
    detail: `Sufficiency Economy Philosophy (SEP) offers a holistic framework for addressing complex and interconnected challenges such as poverty, inequality, environmental degradation, and good governance. In education, SEP promotes balanced development by integrating economic, social, cultural, and environmental dimensions into learning. Schools applying SEP principles can help reduce poverty by promoting practical skills for sustainable livelihoods, foster critical thinking and ethical leadership through participatory decision-making, and nurture a sense of responsibility and community service among students. By encouraging long-term thinking and context-specific solutions, SEP equips learners to contribute to solutions for global issues such as climate change, food security, and social equity while remaining grounded in local realities.`,
  },
];

const CentresOverview = () => {
  const [isLoading, setIsLoading] = useState(true);

  // ฟังก์ชันสำหรับ Scroll ไปยัง Section ตาม ID
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      // offset ให้เว้นระยะจากขอบบนนิดหน่อย (ถ้ามี Header แบบ Fixed)
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <div id="outer-container" style={{}}>
        <Header page="about" sub="thematicAreas" />
        <div className="wrapper bg-white box-index">
          {/* {isLoading ? <Loading /> : null} */}
          <div
            className="position-relative bg-top"
            style={{
              backgroundImage: `url(${bg})`,
            }}
          >
            <div className="w-100 pt-md-5 pb-5">
              <div className="container-fluid pt-5 pb-5 px-lg-5">
                <div className="row text-start justify-content-center">
                  <div className="col-12 col-md-12 col-lg-10">
                    <div className="font-60 weight-700 yellow-black">
                      Thematic Areas
                    </div>
                    <div className="content-custom text-justify">
                      <div className="yellow-black">
                        The six thematic areas of SEAMEO SEPS highlight how the
                        Sufficiency Economy Philosophy (SEP) can be applied
                        across different dimensions of education and development
                        in Southeast Asia. Rooted in values of moderation,
                        reasonableness, and prudence, SEP provides a practical
                        framework for fostering resilience, sustainability, and
                        social well-being. By linking culture, technology, life
                        skills, economic resilience, environment, and responses
                        to interconnected challenges, these thematic areas
                        demonstrate how SEP can enrich teaching and learning
                        while preparing students to thrive in a rapidly changing
                        world. Together, they offer a holistic approach to
                        building more inclusive, ethical, and sustainable
                        societies through education.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* =========================================
              ส่วนที่ 1: แผงปุ่ม Navigation (พื้นหลังเหลือง)
              ========================================= */}
          <section className="py-5" style={{ backgroundColor: "#FAD249" }}>
            <div className="container-fluid px-lg-5">
              {/* แถวสำหรับ Card 5 ใบ */}
              <div className="row justify-content-center mb-4">
                <div className="col-12 col-md-12 col-lg-10 mb-3 mb-lg-0">
                  {/* แถวสำหรับ Card 5 ใบ (แบบสไลด์) */}
                  <div className="mb-5 pb-3 px-3 px-md-0">
                    <Slider
                      dots={true}
                      infinite={false} // ให้ไถสุดแล้วหยุด (ไม่วนลูปกลับ)
                      speed={500}
                      slidesToShow={5} // จอคอมแสดง 5 กล่อง
                      slidesToScroll={1}
                      arrows={false} // ซ่อนลูกศรในมือถือให้ดูคลีน (ใช้ไถเอา)
                      responsive={[
                        {
                          breakpoint: 1024,
                          settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                          },
                        },
                        {
                          breakpoint: 768,
                          settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                          },
                        },
                        {
                          breakpoint: 500,
                          settings: {
                            // ในมือถือตั้งค่า 1.5 หรือ 2 เพื่อให้เห็นกล่องถัดไปโผล่มานิดนึง คนจะได้รู้ว่าปัดได้
                            slidesToShow: 1.3,
                            slidesToScroll: 1,
                          },
                        },
                      ]}
                    >
                      {thematicData
                        .filter((item) => !item.isWideBanner)
                        .map((val, index) => (
                          <div key={index} className="px-2 pb-3">
                            {" "}
                            {/* ใส่ px-2 เพื่อเว้นระยะห่างระหว่างการ์ดในสไลด์ */}
                            <div
                              className="card border-0 cursor-pointer shadow-sm card-hover-effect"
                              style={{
                                borderRadius: "15px",
                                overflow: "hidden",
                                height: "300px", // 1. เปลี่ยนจาก minHeight เป็น height ตายตัวไปเลย ป้องกัน Slider ทำให้กล่องหด
                                backgroundImage: `url(${val.bgImage})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                              }}
                              onClick={() => scrollToSection(val.id)}
                            >
                              {/* 2. เปลี่ยนจาก align-items-center เป็น align-items-start และใส่ pt-4 (Padding Top) เพื่อดันข้อความไว้ด้านบนเหมือนในรูป */}
                              <div
                                className="d-flex align-items-center justify-content-center h-100 w-100 p-2"
                                style={{
                                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                                }}
                              >
                                <h5 className="weight-700 text-center text-dark m-0 pb-5 fs-4 fs-md-2">
                                  {val.title}
                                </h5>
                              </div>
                            </div>
                          </div>
                        ))}
                    </Slider>
                  </div>
                </div>
              </div>
              {/* แถวสำหรับ Banner กว้างด้านล่างสุด */}
              {thematicData
                .filter((item) => item.isWideBanner)
                .map((val, index) => (
                  <div
                    className="row justify-content-center"
                    style={{ marginTop: "-80px" }}
                    key={index}
                  >
                    {/* ย้ายการทำเงา (Drop Shadow) มาไว้ที่ div ครอบ เพื่อไม่ให้ถูก clip-path ตัดหายไป */}
                    <div
                      className="col-12 col-md-10 px-md-4"
                      style={{
                        filter: "drop-shadow(0px 5px 5px rgba(0,0,0,0.15))",
                      }}
                    >
                      <div
                        className="cursor-pointer text-center"
                        style={{
                          // ไล่สีให้เหมือนไฟล์แนบ (เหลือง -> ฟ้า -> เขียวอ่อน -> เหลือง)
                          background:
                            "linear-gradient(90deg, #eedb55 0%, #2ac5cd 25%, #82c982 75%, #f2e555 100%)",
                          // สร้างรูปทรงหกเหลี่ยมแนวยาว (ปลายแหลมซ้าย-ขวา)
                          clipPath:
                            "polygon(35px 0%, calc(100% - 35px) 0%, 100% 50%, calc(100% - 35px) 100%, 35px 100%, 0% 50%)",
                          marginTop: "-100px",
                          position: "relative",
                          zIndex: 10,
                          padding: "16px 50px", // เพิ่ม padding ซ้ายขวาให้ข้อความไม่ไปทับตรงปลายแหลม
                        }}
                        onClick={() => scrollToSection(val.id)}
                      >
                        <h4
                          className="weight-700 text-dark m-0"
                          style={{ fontSize: "1.4rem" }} // ปรับขนาดฟอนต์ให้ใกล้เคียงภาพ
                        >
                          {val.title}
                        </h4>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </section>

          {/* =========================================
              ส่วนที่ 2: เนื้อหาบทความ (พื้นหลังสลับสี ขาว-เทาอ่อน)
              ========================================= */}
          <div className="content-sections">
            {thematicData.map((val, index) => (
              <section
                id={val.id}
                key={index}
                className={`py-5 ${index % 2 === 0 ? "bg-white" : ""}`}
                style={{
                  backgroundColor: index % 2 !== 0 ? "#f8f9fa" : "transparent",
                }} // สีเทาอ่อน (index คี่)
              >
                <div className="container">
                  <div className="row text-start justify-content-center">
                    <div className="col-12 col-md-12 col-lg-10">
                      <div className="sub-topic weight-700 mb-3 text-dark">
                        {val.title}
                      </div>
                      <div
                        className="text-justify content-custom"
                        style={{ fontSize: "16px", lineHeight: "1.6" }}
                      >
                        {val.detail}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            ))}
          </div>

          <Footer page="about" sub="thematicAreas" />
        </div>
      </div>
    </>
  );
};

export default CentresOverview;
